<template>
  <div class="iframe-set" v-show="!!iframe && !!iframe.href && !loading">
    <iframe :name="iframe.name" 
            :src="iframeHref" 
            :ref="`iframe-${iframe.name}`"
            class="iframe" frameborder="0" seamless="" width="100%" height="100%" ></iframe>
    <div class="loading-wrapper" v-if="loading">
      <a-spin tip="Loading...">
        <div class="spin-content">
          正在加载 {{iframe.title}} 
        </div>
      </a-spin>
    </div>
  </div>
</template>
<script>
import { createSsoSt } from '@/api/v1'

//参数值不为空时，存在参数则更新，否则不操作
function updateQueryStringParameter(uri, key, value) {
	if(!value) {
		return uri;
	}
	var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
	var separator = uri.indexOf('?') !== -1 ? "&" : "?";
	if (uri.match(re)) {
		return uri.replace(re, '$1' + key + "=" + value + '$2');
	}
	else {
		return uri + separator + key + "=" + value;
	}
}

export default {
  name: 'DrIframeSet',
  props: ['iframe'],
  data() {
    return {
      loading: false,
      loadingTimeoutIndex: null,
      iframeHref: "about:blank"
    }
  },
  components: {
  },
  watch: {
    iframe: {
      immediate: true,
      handler(newIframe)  {
        if (newIframe != null && newIframe.target === "iframe") {
          this.iframeHref = "about:blank";
          this.showLoading();
          this.loadingTimeoutIndex = window.setTimeout(() => {
            this.hideLoadin("加载组件超时...");
          }, 1000 * 30);
          this.createSsoSt();
        }
      }
    }
  },
  methods: {
    showLoading() {
      this.loading = true;
    },
    hideLoadin(err) {
      this.loading = false;
      if (err != null && err.length > 0) {
        this.iframeHref = "404.html";
        this.$notification['error']({
          message: '提示信息',
          description: err
        });
      }
    },
    createSsoSt() {
      // 从服务端加载组件单点登录票据
      let service = this.iframe.contextPath + this.iframe.href;
      createSsoSt(service).then(response => {
        window.clearTimeout(this.loadingTimeoutIndex);
        this.hideLoadin();

        this.iframeHref = updateQueryStringParameter(service, "ticket", response.data)
      }).catch(() => {
        window.clearTimeout(this.loadingTimeoutIndex);
        this.hideLoadin("加载组件失败...");
      });
    }
  }
}
</script>
<style lang="scss" scoped>
@import './index.scss';
.loading-wrapper {
  z-index: 88889;
}
.spin-content {
    border: 1px solid #91d5ff;
    background-color: #e6f7ff;
    padding: 30px;
  }
</style>
